import { Card, Badge, Tab, Tabs } from 'react-bootstrap';
import './myMeetingRequest.css';
import { useGetMyMeetingSlotRequestList } from '../../apiEndpoints/b2bBuyerSellerEndpoint';
import MyMeetingRequestComm from './MyMeetingRequestComm';

const MyMeetingRequestList = ({
  type,
  user_id,
}: {
  type: 'B2B' | 'Exhibitor';
  user_id: number;
}) => {
  const { data } = useGetMyMeetingSlotRequestList({
    type: type,
    user_id: Number(user_id),
  });

  const pendingData = data?.data?.filter((r) => r?.status === 'Pending');
  const approvedData = data?.data?.filter((r) => r?.status === 'Accepted');
  const rejectedData = data?.data?.filter((r) => r?.status === 'Rejected');

  return (
    <div className='slot-requests-container profile-right-side'>
      {data?.data?.length === 0 ? (
        <Card className='text-center p-4 no-slots-card'>
          <p className='text-muted'>No Meeting Request created yet</p>
        </Card>
      ) : (
        <Tabs defaultActiveKey='pending' className='mb-4'>
          <Tab
            eventKey='pending'
            title={
              <>
                Pending{' '}
                <Badge bg='warning' pill>
                  {pendingData?.length}
                </Badge>
              </>
            }
          >
            <MyMeetingRequestComm showCancelled self='to' data={pendingData} />
          </Tab>

          <Tab
            eventKey='approved'
            title={
              <>
                Approved{' '}
                <Badge bg='success' pill>
                  {approvedData?.length}
                </Badge>
              </>
            }
          >
            <MyMeetingRequestComm self='to' data={approvedData} />
          </Tab>

          <Tab
            eventKey='rejected'
            title={
              <>
                Rejected{' '}
                <Badge bg='danger' pill>
                  {rejectedData?.length}
                </Badge>
              </>
            }
          >
            <MyMeetingRequestComm self='to' data={rejectedData} />
          </Tab>
        </Tabs>
      )}
    </div>
  );
};

export default MyMeetingRequestList;
